import JSZip from 'jszip'

export interface HapVersionInfo {
  versionCode: string
  source: string
}

const HAP_MANIFEST_PATTERNS = [
  /(^|\/)AppScope\/app\.json5$/i,
  /(^|\/)module\.json$/i,
  /(^|\/)pack\.info$/i,
]

const extractVersionCode = (content: string) => {
  const match = content.match(/(?:["']?versionCode["']?)\s*:\s*(?:["']([^"']+)["']|(\d+))/i)
  return (match?.[1] || match?.[2] || '').trim()
}

/**
 * 从鸿蒙 HAP 安装包中读取版本号。
 * 标准包优先使用 AppScope/app.json5；已编译的模块 HAP 则回退至 module.json 或 pack.info。
 */
export async function parseHapVersion(file: File): Promise<HapVersionInfo> {
  const zip = await JSZip.loadAsync(file)
  const fileNames = Object.keys(zip.files)

  for (const pattern of HAP_MANIFEST_PATTERNS) {
    const entryName = fileNames.find(name => pattern.test(name))
    if (!entryName) continue

    const content = await zip.files[entryName].async('text')
    const versionCode = extractVersionCode(content)
    if (versionCode) {
      return { versionCode, source: entryName }
    }
  }

  throw new Error('HAP 中未找到 versionCode')
}
